import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-flow: row wrap;
	flex-basis: content;
	justify-items: stretch;
	gap: var(--margin-4);
	margin-top: 2rem;
	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
	}
`;

export const PieChartWrapper = styled.div`
	width: 30%;
	flex-grow: 1;
	@media ${Breakpoints.tablet} {
		width: 100%;
	}
`;

export const PopperMenu = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--padding-5) var(--padding-2);
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-2);
	box-shadow: var(--container-box-shadow);
	overflow: auto;
	gap: 2rem;
	max-height: 70vh;
	min-width: 24rem;
	width: 30svw;
	& > .typography {
		overflow: unset;
	}
`;

export const PopperMenuItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	&.sticky {
		position: sticky;
		bottom: -2.5rem;
		background-color: var(--white);
		z-index: var(--z-index-1);
		padding-top: var(--padding-2);
	}
`;
